import { render } from "./CmsStoryShield.vue?vue&type=template&id=2298dd1d&lang=html"
import script from "./CmsStoryShield.vue?vue&type=script&lang=js"
export * from "./CmsStoryShield.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__